export const cities = [
    { id: 1, name: "Chandrapur", code: "CHD", state: "Maharashtra", airport: false, popular: false },
    { id: 2, name: "Hyderabad", code: "HYD", state: "Telangana", airport: true, popular: true },
    { id: 3, name: "Bengaluru", code: "BLR", state: "Karnataka", airport: true, popular: true },
    { id: 4, name: "Chennai", code: "CHE", state: "Tamil Nadu", airport: true, popular: true },
    { id: 5, name: "Nagpur", code: "NAG", state: "Maharashtra", airport: true, popular: true },
    { id: 6, name: "Pune", code: "PUN", state: "Maharashtra", airport: true, popular: false },
    { id: 7, name: "Goa", code: "GOA", state: "Goa", airport: true, popular: true },
    { id: 9, name: "Chandrapur", code: "CND", state: "Maharashtra", airport: false, popular: true },
    { id: 10, name: "Kolkata", code: "CCU", state: "West Bengal", airport: true, popular: false },
    { id: 11, name: "Jaipur", code: "JAI", state: "Rajasthan", airport: true, popular: false },
    { id: 12, name: "Ahmedabad", code: "AMD", state: "Gujarat", airport: true, popular: false }
  ];
  